<template>
  <div class="">
    <TonicDetail class="tonic-detail" :id="tonicId" :isToast="false" />
  </div>
</template>

<script>
import TonicDetail from './components/tonic-detail.vue'
export default {
  components: {
    TonicDetail
  },
  data() {
    return {
      tonicId: 0
    }
  },
  created() {
    this.tonicId = +this.$route.query?.id || 0
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.tonic-detail {
  height: 100vh;
}
</style>
